// Launch date utility functions
export const LAUNCH_DATE = new Date('2026-01-15T00:00:00').getTime();

/**
 * Check if the current date is past the launch date
 * @returns {boolean} true if launch date has passed, false otherwise
 */
export const isLaunchDatePassed = () => {
  const now = new Date().getTime();
  return now >= LAUNCH_DATE;
};

/**
 * Get time remaining until launch date
 * @returns {object} Object with days, hours, minutes, seconds remaining
 */
export const getTimeUntilLaunch = () => {
  const now = new Date().getTime();
  const difference = LAUNCH_DATE - now;
  
  if (difference <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
  }
  
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  
  return { days, hours, minutes, seconds, expired: false };
};

/**
 * Format launch date for display
 * @returns {string} Formatted launch date string
 */
export const getFormattedLaunchDate = () => {
  const launchDate = new Date(LAUNCH_DATE);
  return launchDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  });
};
